<template>
<transition name="modal">
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">

        </div>
        <div class="modal-body">
          <pulse-loader></pulse-loader>
        </div>
        <div class="modal-footer">
          <h2>Processing</h2>
          <!-- <button class="modal-default-button" @click="$emit('close')">
            OK</button> -->
        </div>
      </div>
    </div>
  </div>
</transition>
</template>
<script>
/*jshint esversion: 6 */
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  components: {
    PulseLoader
  }
};
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .7);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  /*background-color: rgba(0, 0, 0, .5);*/
  border-radius: 2px;
  /*box-shadow: 0 2px 8px rgba(0, 0, 0, .33);*/
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-footer h2 {
  text-align: center;
  margin-top: 0;
  color: #fff;
}

.modal-body {
  text-align: center;
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}


/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// Modal.vue?c3382b78